<template>

  <div style="overflow: hidden" :style="{
    height : !success ? '100%' :'',
    minHeight : !success ? '100%' :''
  }">


    <div @click="deleteZoom" v-if="client==='mobile' && !success" class="tpl-zoom">
      <img src="https://oss2.1dq.com/app/verify/full.png" width="20px">
    </div>

    <div style="position: absolute ; left: -200px; top: -200px">
      <datetime v-model="date" ref="dateObj"
                type="date"
                zone="Asia/Shanghai"
                format="yyyy-mm-dd"
                :phrases="{ok: '确定', cancel: '取消'}"
                @input="timeClose"
                auto></datetime>
    </div>

    <div class="tpl-box-v31" v-show="!success">
      <div id="pageContainer">
      </div>
    </div>

    <div class="tpl-box-v31" :style="{  minHeight : height + 'px' , background : success ? '#FFFFFF' : ''  }"
         v-show="success">
      <div class="fill-success">
        <div :style="{ paddingTop : height/2 -160 + 'px' }"><img width="60" src="@/assets/success.png"></div>
        <div class="fill-title">{{ success_msg }}</div>
        <div class="fill-des">
          <div>{{ tpl.is_manage ? '如果还需要他人填写，请点击邀请他人填写' : '恭喜您，您已经完成了本次操作' }}</div>
          <div v-if="tpl.is_manage" class="btn share" @click="invitation">邀请他人填写</div>
          <div v-if="tpl.is_manage && showCreateDoc" class="btn createDoc" @click="createWords">
            {{ title ? title : '创建合同' }}
          </div>
        </div>
      </div>
    </div>

    <!--   wap 按钮-->
    <div v-if="client==='mobile'">
      <div class="right-tool-mobile" v-if="!success">
        <div class="right-tool-mobile-box flex-center">
          <div style="width: 50%;  " @click="create" v-if="!tpl.fill_status">
            <div class="btn" style="width: 85%">确认填写内容</div>
          </div>
          <div style="width: 50%;" v-if="!success && tpl.is_manage">
            <div class="btn" @click="getLink" style="background: #828282; width: 85%">邀请他人填写</div>
          </div>
        </div>
      </div>
    </div>
    <!--    wap 按钮结束-->

    <!--    二维码-->
    <qr-link :link="url" :show="showQrcode" @close="showQrcode = false"></qr-link>
    <!--    二维码结束-->
  </div>

</template>

<script>

import {PDFManager} from './js/v32/loadPdf'
import {Datetime} from 'vue-datetime';

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'


import QrLink from "@/components/qr-link";
import load from "@/conf/js/load";
import tool from "@/template/js/v32/tool";


export default {

  name: "create",
  /**
   * 接受消息
   */
  mounted() {
    window.onload = () => {
      window.addEventListener('message', json => {
        switch (json.data.action) {
          case "create" :
            return this.create();
          case "getLink" :
            return this.getLink()
        }
      }, false)
    }

  },
  data() {
    return {
      date: '',
      date_id: "",
      client: this.$route.query.client || 'mobile',
      url: "", // 二维码链接
      fill_id: this.$route.query.fill_id || "", //填写的id
      tpl_token: this.$route.query.tpl_token || "", //邀请他人填写的token
      title: this.$route.query.title, //填写的id
      success: false, //成功提示
      showQrcode: false, //是否显示二维码
      height: 600, // 页面高度
      success_msg: "内容填写成功",
      showCreateDoc: false, //是否显示创建合同按钮
      tpl: {
        fill_status: true,
        id: this.$route.query.id || "",
        is_manage: false, //是否管理
        file_id: "",
        field: []
      }
    };
  },

  components: {QrLink, Datetime},
  methods: {

    /**
     * 放大
     */
    deleteZoom() {

      let contentNoZoom = "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover";
      let contentZoom = "width=device-width,initial-scale=1.0, minimum-scale=yes, maximum-scale=2.0"
      let content = document.getElementsByName("viewport")[0].getAttribute("content");
      if (content === contentNoZoom)
        this.api.alert("您已经开启双指可放大功能，再次点击可关闭")
      else
        this.api.alert("您已经关闭双指可放大功能，再次点击可开启")
      document.getElementsByName("viewport")[0].setAttribute("content", content === contentZoom ? contentNoZoom : contentZoom);

    },
    /**
     * 时间选择完成
     * @param e
     */
    timeClose(e) {
      if (this.date_id)
        document.getElementById(this.date_id).value = e.slice(0, 10);
    },

    /**
     * 邀请他人填写
     * @returns {*}
     */
    invitation() {
      if (this.client === 'mobile') {
        uni.navigateTo({
          url: "/pages/users/v3template/qrcode?url=" + this.url
        })
        return;
      }
      this.showQrcode = true
    },
    /**
     * 获取链接
     */
    getLink() {

      if (!this.tpl.file_id)
        return this.api.alert("请等待系统加载完成")

      this.api.loading()
      this.api.post("/v1/V32Template/getLink", {
        id: this.tpl.id,
        field: this.tpl.field,
        fill_id: this.fill_id,
        tpl_token: this.tpl_token
      }, json => {
        this.api.hideLoading()
        if (json.code === 200) {
          this.fill_id = json.data.fill_id
          this.url = json.data.url
          this.success = true
          this.success_msg = "请等待他人填写"
          if (this.client === 'mobile') {
            return uni.navigateTo({
              url: "/pages/users/v3template/qrcode?url=" + this.url
            })
          } else {
            this.showQrcode = true
            //隐藏按钮
            window.parent.postMessage({
              action: 'hideCreateBtn'
            }, '*')
          }
        } else
          this.api.alert(json.msg);
      });
    },

    /**
     * 创建合同
     */
    createWords() {
      //如果是app
      if (this.client === 'mobile') {
        return uni.redirectTo({
          url: "/pages/users/contractManagement/createDoc?fill_id=" + this.fill_id + "&file_name=" + this.tpl.name
        });
      }
      window.parent.postMessage({
        action: 'createDoc',
        fill_id: this.fill_id
      }, '*')
    },
    /**
     * 读取数据
     */
    read() {
      this.api.loading()
      this.api.post(
          "/v1/V32Template/read",
          {
            id: this.tpl.id,
            fill_id: this.fill_id,
            tpl_token: this.tpl_token
          }, (json) => {
            if (json.code === 200) {
              this.tpl = json.data

              if (this.$route.query.channel === "api")
                this.tpl.is_manage = false

              //加载pdf
              this.loadPdf(this.tpl.file_url, this.tpl.fill_field, this.tpl.field);

            } else if (json.code === 103) {
              this.api.hideLoading()
            } else {
              this.api.hideLoading()
              this.api.alert(json.msg)
            }
          })
    },

    /**
     * 加载pdf
     * @param file_url
     * @param fill_field
     * @param field
     */
    loadPdf(file_url, fill_field, field) {
      PDFManager.loadPDF(file_url, fill_field, field, () => {
        //加载完成
        tool.updateTimeObj((event, id, value) => {
          this.$refs.dateObj.open(event);
          this.date_id = id
          if (value)
            this.date = value
        });
        //隐藏加载
        this.api.hideLoading()
      });
    },

    /**
     * 填写合同
     */
    create() {

      let data = tool.getFiledContent();
      //  console.log(data)
      // return  ;

      if (!this.tpl.file_id)
        return this.api.alert("请等待系统加载完成")

      this.api.loading()


      this.api.post("/v1/V32Template/fill", {
        id: this.tpl.id,
        field: data,
        fill_id: this.fill_id,
        tpl_token: this.tpl_token
      }, json => {
        this.api.hideLoading()
        if (json.code === 200) {
          this.fill_id = json.data.fill_id
          this.url = json.data.url
          this.success = true
          this.showCreateDoc = true
          //隐藏按钮
          window.parent.postMessage({
            action: 'hideCreateBtn'
          }, '*')
        } else
          this.api.alert(json.msg);
      });
    }


  },
  created() {
    load.js("/js/scroll.js")
    this.read()
    this.height = document.documentElement.clientHeight
  }

};
</script>
<style scoped>
.tpl-box-v31 {
  margin: 0 auto;
  width: 100%;
  text-align: center;
  max-width: 870px;
  /*background: #FFFFFF*/
}

.flex-center {
  /*justify-content: flex-start | flex-end | center | space-between | space-around;*/
  justify-content: center;
}

.fill-title {
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
  color: #585858;
  margin-bottom: 10px;
}

.fill-des {
  color: #acacac;
  font-weight: 300;
  margin-top: 5px;
  font-size: 12px
}


.fill-success img {
  width: 60px;
}

.share {
  background: rgb(160, 160, 160);
  margin-top: 20px;
  max-width: 140px
}

.createDoc {
  margin-top: 20px;
  max-width: 140px;
  margin-left: 15px
}

.tpl-zoom {
  position: fixed;
  cursor: pointer;
  z-index: 9;
  background: rgb(255 255 255);
  color: rgb(255, 255, 255);
  display: block;
  text-align: center;
  padding: 6px;
  border: 1px solid #a6a6a6;
  border-radius: 3px;
  bottom: 90px;
  right: 10px;
}
</style>
